import { useFileUrl } from '~/hooks/use-file-url';

type OrganizationLogoProps = {
  logoUrl?: string | null;
  alt?: string;
  className?: string;
  fallbackClassName?: string;
};

export function OrganizationLogo({
  logoUrl,
  alt = 'logo',
  className = '',
  fallbackClassName = '',
}: OrganizationLogoProps) {
  const { url, isLoading } = useFileUrl(logoUrl);

  if (isLoading) {
    return (
      <div
        className={`bg-gray-200 animate-pulse rounded ${fallbackClassName || className}`}
      />
    );
  }

  return <img src={url} alt={alt} className={className} />;
}
